import { Component, ElementRef, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { DataStateChangeEvent, FilterService, GridDataResult, PageChangeEvent } from '@progress/kendo-angular-grid';
import { Router } from '@angular/router';
import { Common } from 'src/app/common/common';
import { CompositeFilterDescriptor, process, State, filterBy, FilterDescriptor } from '@progress/kendo-data-query';
import { CommonService } from 'src/app/service/common/common.service';
import { IDonorInformation } from 'src/app/interface/IDonorContact';

const flatten = filter => {
  const filters = (filter || {}).filters;
  if (filters) {
    return filters.reduce((acc, curr) => acc.concat(curr.filters ? flatten(curr) : [curr]), []);
  }
  return [];
};

const distinctDonorAgency = data => data.map(x => x)
  .filter((x, idx, xs) => xs.findIndex(y => y.agencyName === x.agencyName) === idx);

const distinctCity = data => data.map(x => x)
  .filter((x, idx, xs) => xs.findIndex(y => y.city === x.city) === idx);

const distinctState = data => data.map(x => x)
  .filter((x, idx, xs) => xs.findIndex(y => y.state === x.state) === idx);

const distinctCountry = data => data.map(x => x)
  .filter((x, idx, xs) => xs.findIndex(y => y.countryName === x.countryName) === idx);

const distinctIsActive = data => data.map(x => x)
  .filter((x, idx, xs) => xs.findIndex(y => y.isActive === x.isActive) === idx);

@Component({
  selector: 'app-donor-list',
  templateUrl: './donor-list.component.html',
  styleUrls: ['./donor-list.component.scss']
})

export class DonorListComponent implements OnInit {
  constructor(private router: Router, private commonService: CommonService) { }

  public gridData: GridDataResult;
  public donorList: IDonorInformation[] = [];
  public pageSize = 10;
  public skip = 0;
  public typedg: 'numeric' | 'input' = 'numeric';
  public buttonCount = 5;
  public info = true;
  public pageSizes = true;
  public previousNext = true;
  public text: string = '';
  public enteredSearchText: string = '';
  public reqstate: State = {
    skip: 0,
    take: this.pageSize
  };
  public selectedCountry: string;
  public filter: CompositeFilterDescriptor;
  public filteredData: any = [];
  // column filter
  public categoryFilter: any[] = [];
  public agencyName: any[] = [];
  public city: any[] = [];
  public state: any[] = [];
  public country: any[] = [];
  public isActive: any[] = [];

  pageChange({ skip, take }: PageChangeEvent): void {
    this.skip = skip;
    this.pageSize = take;
  }

  filterChange(filter: CompositeFilterDescriptor): void {
    this.filter = filter;
    const filterData = filterBy(this.donorList, filter);
    this.gridData = process(filterData, this.reqstate);
  }

  dataStateChange(state: DataStateChangeEvent): void {
    this.reqstate = state;
    if (this.filteredData.length > 0) {
      this.gridData = process(this.filteredData, this.reqstate);
    } else {
      this.gridData = process(this.donorList, this.reqstate);
    }
  }

  ngOnInit(): void {
    Common.loader('show');
    this.getDonors();
  }

  onLoadServers(id: number) {
    this.router.navigate(['/servers', id, 'edit'], { queryParams: { allowedit: id }, fragment: 'loading' });
  }

  getDonors() {
    this.commonService.getDonors().subscribe((response) => {
      if (response.length > 0) {
      this.donorList = response;
      this.donorList.forEach((el) => {
        el.isActive = el.isActive === true ? 'Yes' : 'No';
      });
      this.gridData = {
        data: this.donorList.slice(this.skip, this.skip + this.pageSize),
        total: this.donorList.length
      };
      this.agencyName = distinctDonorAgency(this.donorList.filter((x) => x.agencyName !== null));
      this.city = distinctCity(this.donorList.filter((x) => x.city && x.city.trim()));
      this.state = distinctState(this.donorList.filter((x) => x.state && x.state.trim()));
      this.country = distinctCountry(this.donorList.filter((x) => x.countryName && x.countryName.trim()));
      this.isActive = distinctIsActive(this.donorList.filter((x) => x.isActive !== null));
    }
      Common.loader('hide');
    });
  }

  // grid column filter
  public categoryFilters(filter: CompositeFilterDescriptor): FilterDescriptor[] {
    this.categoryFilter.splice(
      0, this.categoryFilter.length,
      ...flatten(filter).map(({ value }) => value)
    );
    return this.categoryFilter;
  }

  public agencyNameChange(values: any[], filterService: FilterService): void {
    filterService.filter({
      filters: values.map(value => ({
        field: 'agencyName',
        operator: 'eq',
        value
      })),
      logic: 'or'
    });
  }

  public cityChange(values: any[], filterService: FilterService): void {
    filterService.filter({
      filters: values.map(value => ({
        field: 'city',
        operator: 'eq',
        value
      })),
      logic: 'or'
    });
  }

  public stateChange(values: any[], filterService: FilterService): void {
    filterService.filter({
      filters: values.map(value => ({
        field: 'state',
        operator: 'eq',
        value
      })),
      logic: 'or'
    });
  }

  public countryNameChange(values: any[], filterService: FilterService): void {
    filterService.filter({
      filters: values.map(value => ({
        field: 'countryName',
        operator: 'eq',
        value
      })),
      logic: 'or'
    });
  }

  public isActiveChange(values: any[], filterService: FilterService): void {
    filterService.filter({
      filters: values.map(value => ({
        field: 'isActive',
        operator: 'eq',
        value
      })),
      logic: 'or'
    });
  }

}
